require('dotenv').config();

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYandexMetrika from 'vue-yandex-metrika'
// import vClickOutside from 'v-click-outside'
import Vuex from 'vuex'
import * as Sentry from "@sentry/vue";
// Plugins
import Multiselect from 'vue-multiselect'
import Vuelidate from 'vuelidate'
// import ToggleButton from 'vue-js-toggle-button'
import DatePicker from 'vue2-datepicker'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import App from './App'
import Http from './API/index'
import Storage from './Store/Store'
import Global from './Global'
import SideBar from './components/UIComponents/Plugins/SidebarPlugin'
import ScaleLoader from 'vue-spinner/src/ScaleLoader'
import VTree from "vue-tree-halower";
import Notifications from './components/UIComponents/Plugins/NotificationPlugin'

import commonMixin from '@/mixins/common'

import * as VueGoogleMaps from 'vue2-google-maps'

// router setup
import routes from './routes/routes'
import access from './routes/access'

import VModal from 'vue-js-modal'
// library imports
import 'es6-promise/auto'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/paper-dashboard.scss'
// translate
import translate from './translate'

import Clipboard from './components/UIComponents/services/clipboard'
import MultiLanguage from 'vue-multilanguage'

import VueCodemirror from 'vue-codemirror'

// Импорт базовых стилей CodeMirror
import 'codemirror/lib/codemirror.css'
// Импорт нужных режимов (например, для JavaScript)
import 'codemirror/mode/toml/toml.js'
import 'codemirror/theme/neat.css'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Vuex)
Vue.use(SideBar)
Vue.use(VueRouter)
Vue.use(Multiselect)
Vue.use(Vuelidate)
// Vue.use(ToggleButton)
// Vue.use(vClickOutside)
Vue.use(Notifications)
Vue.use(DatePicker)
Vue.use(Global)
Vue.use(VModal, { dialog: true, dynamic: true, adaptive: true, clickToClose: true, scrollable: true })
// Vue.use(VuePrism);
Vue.use(VueCodemirror)

Vue.use(Viewer, {
  defaultOptions: {
    navbar: false,
    toolbar: false,
    title: false,
    fullscreen: true,
    movable: true,
    zoomable: true,
  }
})


Vue.component('ScaleLoader', ScaleLoader)
Vue.component('VTree', VTree)

const store = new Vuex.Store({
  modules: Storage
})
// configure router

const router = new VueRouter({
  routes: routes.MyRoute.def(),
  mode: 'history',
  linkActiveClass: 'active'
})

Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return this.$root.http
  }
})

Object.defineProperty(Vue.prototype, '$routers', {
  get () {
    return this.$root.routers
  }
})

Object.defineProperty(Vue.prototype, '$clipboard', {
  get () {
    return new Clipboard(this)
  }
})

Object.defineProperty(Vue.prototype, 'localStorage', {
  get () {
    return window.localStorage
  }
})

Vue.use(MultiLanguage, translate)

Vue.mixin(commonMixin)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: function() {
    return {
      http: Http,
      routers: null,
      loading: true,
      access: access,
      attribute: {
        name_company: 'Sistematics',
        company_url: 'https://sistematics.ru',
        logo_url: ""
      },
      handleVisibility: true
    };
  },
  computed: {
    auth () { return this.$store.getters.getAuth },
    document_title () {
      return this.$store.state.main.other_title ? this.$store.state.main.other_title : this.$store.state.main.main_title
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
    load_page () {
      return this.$store.getters.getLoadPage
    },
    visibility_state(){
      return this.$store.getters.getVisibilityState
    }
  },
  watch: {
    $route(){
      if (this.$route.hash.indexOf('#') !== -1){
        this.$router.push(this.$route.hash.replace('#', ''))
      }
    },
    document_title () {
      Vue.nextTick(() => {
        document.title = this.document_title;
      });
    },
    auth: {
      handler(new_val, old_val){
        if (this.auth !== true) {
          if (this.$router.currentRoute.path !== '/auth') {
            if (this.localStorage.getItem('logout') !== '1') {
              this.localStorage.setItem('path', this.$route.path)
            }
            this.$router.push('/auth')
          }
        } else {
          this.$store.dispatch('startPreload')
          this.UpdateRoutes() // обновляем доступные разделы
        }

        if (new_val === true && old_val === false) {  //Возможно, можно сделать лучше
          this.timer = setInterval(() => {
            if (Object.keys(this.$store.getters.getPermissions).length > 0) {
              if (this.localStorage.getItem('path')) {
                let path = this.localStorage.getItem('path')
                this.localStorage.setItem('path', '')
                this.$router.push(path)
              } else {
                if (this.$store.getters.getPermissions.viewDashboard) {
                  this.$router.push('/dashboard')
                }else{
                  this.$router.push('/')
                }
              }
              clearInterval(this.timer)
            }
          }, 10)
        }
        // Данный блок кода проверяет предыдущее состояние переменной auth, и сравнивает с новым.
        // При смене состояния c false на true идёт отслеживание permissions и в зависимости от них,
        // нас отправляет на стартовую страницу /device_list или /dashboard
      }
    },

    this_route () {
      this.$modal.hide('dynamic-modal')
    },
    visibility_state(){
      if (this.visibility_state && this.$store.getters.getHardRestart) location.reload(true)
    }
  },
  beforeMount () {
    this.$store.dispatch('checkVisibility')

    this.http.v1.getProps((response)=> {
      // this.attribute.name_company = response.data.company;
      // this.attribute.company_url =  response.data.company_url;
      response.data.title ? this.$store.commit('updateMainTitle', response.data.title) : '';
      this.$store.commit('updateDatetimePicker', response.data.datetime_picker_period_days)
      this.$store.commit('updateVersionMonitoringFront', response.data.version)

      let yandex_metric_id = response.data.yandex_metric_id ? response.data.yandex_metric_id : process.env.VUE_APP_YANDEX_MATRIC_ID
      let google_maps_key = response.data.google_maps_key ? response.data.google_maps_key : process.env.VUE_APP_GOOGLE_MAPS_KEY

      if (response.data.sentry_environment){
        Sentry.init({
          Vue,
          dsn: process.env.VUE_APP_SENTRY,
          environment: response.data.sentry_environment,
          release: 'frontend-vue@' + response.data.version,

          integrations: [
            new Sentry.BrowserTracing({
              routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay({
              maskAllText: true,
              blockAllMedia: true,
            }),
          ],

          tracesSampleRate: 1.0,
          replaysSessionSampleRate: 0.1,
          replaysOnErrorSampleRate: 1.0,

        });
      }

      try{
        Vue.use(VueYandexMetrika, {
          id: yandex_metric_id,
          router: router,
          env: process.env.NODE_ENV
        })
      } catch {
        this.global_notify('danger', "Error yandex_metric")
        console.error("Error yandex_metric")
      }

      try{
        Vue.use(VueGoogleMaps, {
          load: {
            key: google_maps_key,
            libraries: 'places'
          }
        })
      } catch {
        this.global_notify('danger', "Error Google Maps")
        console.error("Error Google Maps")
      }
    })

    this.getStatusUser()

    this.http.v1.bad_answer = this.http.simcard.bad_answer = (response) => {
      if (response.status === 401) {
        this.$store.commit('updateAuth', false)
        if (this.localStorage.getItem('auth') !== null) {
          this.global_notify('danger', this.translate('http.session_failed'))
        }
        this.localStorage.removeItem('auth')
        if (this.$route.path !== '/auth') {
          this.localStorage.setItem('path', this.$route.path)
        }
        this.$store.commit('logout')
      } else if (response.status === 403) {
        this.global_notify('danger', this.translate('http.access_denied'))
      } else {
        this.bad_answer_handler(response)
      }
    }

    this.$router.beforeResolve((to, from, next) => {
      if (to.path === '/auth' || to.path === '/notfound'){
        next()
      }else if (access.prove(this.permissions, to.name, to.params)) {
        next()
      } else {
        next('/notfound')
      }
    })
  },
  methods: {
    getStatusUser () {
      if (this.localStorage.getItem('auth') !== null) {
        this.$http.v1.getUserStatus((resp) => {
          this.$store.commit('updateAuth', true)
          this.$store.commit('updateUser', resp.data.user)


          if (resp.data.props){
            this.$root.attribute.name_company = resp.data.props.company;
            this.$root.attribute.company_url =  resp.data.props.company_url;
            this.$root.attribute.logo_url =  resp.data.props.custom_logo;
          }

          this.$store.commit('setGlobalTiming', resp.data.front_timers)
          this.$store.commit('updateModules', resp.data.monitoring_modules)
          this.$store.commit('updateSettings', resp.data.settings)

          this.$store.dispatch("WSConnect",resp.data.servicebridge_url)
        }, () => {
          this.localStorage.removeItem('auth')
          this.$store.commit('updateAuth', false)
        })
      } else {
        this.$store.commit('updateAuth', false)
      }
    },
    UpdateRoutes(){
      let timer = setInterval(() => {
        if (Object.keys(this.$store.getters.getPermissions).length > 0) {
          clearInterval(timer)
          this.$router.addRoute(routes.MyRoute.user());
        }
      }, 10)
    },
  },
  render: h =>
    h(App, {})
})
